<div
  class="login-body"
  [ngClass]="{ 'layout-dark': !dark, 'layout-light': dark }"
  style="
    background: url('../../assets/layout/images/login_bg/2.1.png');
    background-repeat: no;
    background-size: cover;
    background-position: center;
  "
>
  <div class="login-content">
    <div class="login-panel">
      <div class="login-panel-content">
        <div class="logo">
          <img src="assets/layout/images/logo.png" alt="mirage-layout" />
        </div>
        <h1>Sign in to RadPortal</h1>
        <p>Welcome. Please Sign in to the RadPortal Network.</p>
        <form
          [formGroup]="_loginForm"
          novalidate
          autocomplete="off"
          (ngSubmit)="onSubmit()"
        >
          <div class="forms">
            <div class="login-input-wrapper">
              <label for="username">Email</label>
              <input
                type="text"
                id="username"
                pInputText
                autocomplete="off"
                placeholder="Email"
                formControlName="UserEmail"
              />
              <i class="pi pi-envelope"></i>
            </div>

            <div class="login-input-wrapper">
              <label for="password">Password</label>
              <input
                type="password"
                pInputText
                placeholder="Password"
                formControlName="Password"
                id="password"
                autocomplete="off"
                pPassword
                [feedback]="false"
              />
              <i class="pi pi-lock"></i>
            </div>

            <div class="captcha-container" *ngIf="failedAttempts > 2">
              <div
                class="google-recaptcha"
                *ngIf="
                  config?.setting?.IsInternetAllow;
                  else elseIsInternetAllow
                "
              >
                <div class="mb-3 text-center captcha-img-row">
                  <re-captcha
                    [siteKey]="siteKey"
                    (resolved)="onRecaptchaResolved($any($event))"
                    (error)="onRecaptchaError()"
                  >
                  </re-captcha>
                </div>
              </div>
              <ng-template #elseIsInternetAllow>
                <div class="custom-recaptcha-wrap">
                  <div class="custom-recaptcha-img">
                    <img
                      *ngIf="captchaBase64"
                      [src]="'data:image/png;base64,' + captchaBase64"
                      alt="CAPTCHA"
                      class="captcha-img"
                    />
                    <button
                      type="button"
                      class="ml-5"
                      pButton
                      icon="pi pi-refresh"
                      (click)="onRefreshCaptcha()"
                      class="p-button-text p-button-rounded captcha-refresh-btn"
                      title="Refresh CAPTCHA"
                    ></button>
                  </div>

                  <div class="custom-recaptcha-input">
                    <div class="p-inputgroup captcha-input">
                      <input
                        class="captcha-input-field"
                        type="text"
                        pInputText
                        placeholder="Enter CAPTCHA"
                        [(ngModel)]="userCaptcha"
                        [ngModelOptions]="{
                          standalone: true
                        }"
                        autocomplete="off"
                        maxlength="6"
                        minlength="6"
                      />
                      <button
                        pButton
                        label="Verify"
                        type="button"
                        class="mat-login-btn"
                        (click)="onCaptchaValidation()"
                        [disabled]="userCaptcha.length !== 6"
                      ></button>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>

            <div class="col-12">
              <p-checkbox
                [(ngModel)]="checked"
                [ngModelOptions]="{
                  standalone: true
                }"
                label="Remember me"
                value="SaveInfo"
                binary="true"
              ></p-checkbox>
            </div>

            <div class="buttons">
              <button
                pButton
                type="submit"
                [disabled]="failedAttempts > 2"
                label="Sign In"
              ></button>
              <a
                style="cursor: pointer"
                (click)="gotoForgetPassword()"
                class="secondary-button"
                >Forgot Password?</a
              >
            </div>
          </div>
        </form>

        <div class="text-left mt-5">
          No account ?
          <a href="https://radportal.net/signup">Sign up</a>
        </div>
        <div class="text-left mt-3">
          <a style="cursor: pointer" (click)="goToLink()">Login with Line</a>
        </div>
      </div>
    </div>

    <div class="desert"></div>
  </div>
</div>

<div *ngIf="loaderVisible" class="loading-overlay">
  <div class="loader"></div>
</div>

<p-confirmDialog
  header="Confirmation"
  key="CheckDuplicateUser"
  icon="pi pi-exclamation-triangle"
  message="Do you want to delete?"
  [style]="{ width: '350px' }"
  acceptButtonStyleClass="p-button-text"
  rejectButtonStyleClass="p-button-text"
></p-confirmDialog>
